// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"_1sOUVXs6HmmiFEgk488Ki6","headerDarkTheme":"_1Ly6OvbkOXb3HyMNHtPg9S","username":"_2FL3dwtiNz4GLeKiwfwXg0"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/chat/chat-messages/message-history/header-conversation/HeaderConversation.css
// module id = 287
// module chunks = 0